/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { FasTimes } from 'assets/icons';
import { ATCONSTANTS as ATC, allowedFileTypes } from 'appconstants';

function FileUploader({
  uploadedFile, onChange, multi
}) {
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      if (multi) {
        onChange(acceptedFiles);
      } else {
        onChange(acceptedFiles[0]);
      }
    }
  }, [multi, onChange]);

  const {
    getRootProps, getInputProps, isDragActive, fileRejections
  } = useDropzone({
    onDrop,
    multiple: multi,
    accept: allowedFileTypes
  });

  const onDelete = (e) => {
    onChange(null);
    e.stopPropagation();
    e.preventDefault();
  };

  const placeholder = isDragActive ? 'Drop the file here ...' : 'Drag and drop a file here, or click to select file';

  const loadFile = () => (multi ? (
    <span>{placeholder}</span>
  ) : (
    <div className="attachment-dropzone-file">
      <span data-id={`${ATC.APP}FILE_NAME{ATC.LABEL}`} className="color-dark-blue">
        {uploadedFile.name}
      </span>
      <button
        data-id={`${ATC.APP}DELETE_FILE{ATC.BUTTON}`}
        onClick={onDelete}
        type="button"
        className="fn-btn close"
        title="Delete"
      >
        <FasTimes data-id={`${ATC.APP}DELETE_FILE_ICON{ATC.BUTTON}`} />
      </button>
    </div>
  ));

  const fileRejectionItems = fileRejections.map(({ file }) => (
    <div key={file.path} className="file-upload-error-box">
      <p className="pl-5">
        {`${file.path} - ${file.size} bytes`}
      </p>
      <p className="pl-5">
        {`allowed file types are : ${Object.values(allowedFileTypes).join(', ')}`}
      </p>
    </div>
  ));

  return (
    <>
      <div className="attachment-dropzone mt-2">
        <div {...getRootProps()} className="d-flex align-items-center font-btn ml-2" style={{ height: '100%' }}>
          <div>
            <input {...getInputProps()} />
            {uploadedFile == null ? <p className="color-dark-grey">{placeholder}</p> : loadFile()}
          </div>
        </div>
      </div>
      {fileRejectionItems && fileRejectionItems.length > 0 ? (
        <div className="form-layout-wrapper">
          <div className="form-layout-body">
            <div className="form-layout-message-error">
              {fileRejectionItems}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default FileUploader;
